/**
 * Builds reset variables for retrying the `TradeRulePrioritizeNominatedRoute_Query`.
 * The GraphQL query accepts `$uuid: ID!` and `$meterId: ID!`, both sourced directly
 * from the matched route params (e.g.
 * `/properties/:uuid/meters/:meterId/trade-rules/nominated/prioritize`).
 * @param {object} props - Route props provided by found-relay.
 * @param {object} props.match - The matched route object.
 * @param {object} props.match.params - URL parameters extracted from the matched route.
 * @param {string} props.match.params.uuid - The property UUID from the route path.
 * @param {string} props.match.params.meterId - The meter UUID from the route path.
 * @returns {{uuid: string, meterId: string}|null} Retry variables, or `null` if either
 *   the `uuid` or `meterId` parameter is missing.
 */
function buildTradeRulePrioritizeNominatedRetryVariables(props) {
  const routeUuid = props?.match?.params?.uuid;
  const routeMeterId = props?.match?.params?.meterId;

  if (!routeUuid || !routeMeterId) {
    return null;
  }

  return {
    uuid: routeUuid,
    meterId: routeMeterId,
  };
}

export default buildTradeRulePrioritizeNominatedRetryVariables;
